import { render, staticRenderFns } from "./OrganizationQuestionList.vue?vue&type=template&id=621571d7&scoped=true&"
import script from "./OrganizationQuestionList.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrganizationQuestionList.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./OrganizationQuestionList.vue?vue&type=style&index=0&id=621571d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621571d7",
  null
  
)

export default component.exports